import ReactGA from 'react-ga4';

export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
  
  if (measurementId) {
    ReactGA.initialize(measurementId, {
      testMode: environment === 'development', // Prevents data pollution in development
      debug: environment === 'development'      // Enhanced logging in development
    });
    
    console.log(`Google Analytics initialized for ${environment}:`, measurementId);
  } else {
    console.warn('GA Measurement ID not found');
  }
};

export const trackPageView = (path) => {
  ReactGA.send({ 
    hitType: 'pageview', 
    page: path 
  });
};

export const trackEvent = (eventName, parameters = {}) => {
  ReactGA.event(eventName, parameters);
};

// Track environment info for debugging
export const trackEnvironment = () => {
  const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
  
  ReactGA.event('environment_info', {
    environment: environment,
    timestamp: new Date().toISOString()
  });
};

// Enhanced contact form tracking with environment context
export const trackContactFormSubmit = () => {
  const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
  
  ReactGA.event('form_submit', {
    category: 'engagement',
    label: 'contact_form',
    environment: environment
  });
  
  if (environment === 'development') {
    console.log('Development: Contact form submission tracked');
  }
};

export const trackPortfolioClick = (projectName) => {
  const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
  
  ReactGA.event('portfolio_click', {
    category: 'engagement',
    label: projectName,
    environment: environment
  });
};

export const trackServiceInquiry = (serviceName) => {
  const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
  
  ReactGA.event('service_inquiry', {
    category: 'lead_generation',
    label: serviceName,
    environment: environment
  });
  
  if (environment === 'development') {
    console.log(`Development: Service inquiry tracked - ${serviceName}`);
  }
};
